import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import FloatingButtons from '@/pages/home/components/FloatingButtons';
import ContactSection from '@/pages/home/components/ContactSection';

function IletisimHero() {
  return (
    <section className="relative pt-32 pb-20 bg-brand-navy overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/media/search-image-fe9133ce28.jpg"
          alt="İletişim"
          className="w-full h-full object-cover object-top opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-navy via-brand-navy/90 to-brand-navy/70"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-2 mb-6">
          <a href="/" className="text-white/50 text-sm hover:text-white transition-colors cursor-pointer">Anasayfa</a>
          <span className="text-white/30 text-sm">/</span>
          <span className="text-brand-orange text-sm font-medium">İletişim</span>
        </div>
        <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-4">Bize Ulaşın</p>
        <h1 className="text-white font-heading font-bold text-4xl md:text-5xl mb-6 leading-tight">
          Hızlı & Kolay<br />
          <span className="text-brand-orange">İletişim</span>
        </h1>
        <p className="text-white/60 text-base md:text-lg max-w-xl leading-relaxed">
          Fiyat teklifi almak, bilgi edinmek veya herhangi bir konuda destek için 7/24 ulaşabilirsiniz. Size en kısa sürede dönüş yapacağız.
        </p>
        <div className="flex flex-wrap gap-4 mt-8">
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <span className="w-5 h-5 flex items-center justify-center text-brand-orange">
              <i className="ri-time-line text-base"></i>
            </span>
            7/24 Aktif
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <span className="w-5 h-5 flex items-center justify-center text-brand-orange">
              <i className="ri-translate-2 text-base"></i>
            </span>
            TR & DE Dil Desteği
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <span className="w-5 h-5 flex items-center justify-center text-brand-orange">
              <i className="ri-send-plane-line text-base"></i>
            </span>
            5 dk. içinde yanıt
          </div>
        </div>
      </div>
    </section>
  );
}

export default function IletisimPage() {
  return (
    <main className="font-sans">
      <Navbar />
      <IletisimHero />
      <ContactSection />
      <Footer />
      <FloatingButtons />
    </main>
  );
}
